function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(.336 -.033)"
}, React.createElement("path", {
  fill: "#FE2F00",
  d: "M19.3535579,19.3711365 C19.3535579,20.1305281 18.7379494,20.7461365 17.9785579,20.7461365 L1.4785579,20.7461365 C0.719166366,20.7461365 0.103557897,20.1305281 0.103557897,19.3711365 L0.103557897,1.49613654 C0.103557897,0.736745009 0.719166366,0.12113654 1.4785579,0.12113654 L15.2285579,0.12113654 C15.5871558,0.121172502 15.9315518,0.261299239 16.1883079,0.51163654 L18.9383079,3.15438654 C19.203785,3.41315432 19.3535217,3.76815905 19.3535579,4.13888654 L19.3535579,19.3711365 Z"
}), React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M8.11339123,14.4761365 C7.87016264,14.5974275 7.58148837,14.5842112 7.35036009,14.441203 C7.11923182,14.2981947 6.9785695,14.0457633 6.9785579,13.7739699 L6.9785579,8.46830321 C6.9785695,8.19650982 7.11923182,7.9440784 7.35036009,7.80107012 C7.58148837,7.65806183 7.87016264,7.64484556 8.11339123,7.76613654 L13.4199746,10.4198865 C13.6857635,10.5525509 13.8537067,10.8240783 13.8537067,11.1211365 C13.8537067,11.4181948 13.6857635,11.6897222 13.4199746,11.8223865 L8.11339123,14.4761365 Z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    className: "icon",
    style: {
      "height": "1em",
      "width": "0.95238em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/video-file.79dd6cf2.svg";
export { SvgComponent as ReactComponent };